import * as apiGetStartingWith from 'api/baseIngredient/GetBaseIngredientStartingWithV1';
import * as apiPostSearch from 'api/baseIngredient/PostBaseIngredientSearchV1';
import { ISelectItem } from 'interfaces/ISelectItem';
import * as BaseIngredientList from 'types/BaseIngredient/Search/BaseIngredientList';
import * as RangeWithIdList from 'types/BaseIngredient/Search/RangeWithIdList';
import * as Search from 'types/BaseIngredient/Search/Search';

export type Type = {
	data: BaseIngredientList.Type;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	ranges: RangeWithIdList.Type;
};

export function create(): Type {
	return {
		data: BaseIngredientList.create(),
		hasNextPage: false,
		hasPreviousPage: false,
		pageIndex: 0,
		pageSize: 0,
		ranges: RangeWithIdList.create(),
		totalCount: 0,
		totalPages: 0,
	};
}

export async function getFromApi(search: Search.Type): Promise<Type> {
	const response = await apiPostSearch.callApi(Search.mapToApi(search));
	const responseData = response.toNullable();
	if (responseData) return mapFromApi(responseData);
	return create();
}

export async function getFromApiSW(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<ISelectItem[]> {
	const response = await apiGetStartingWith.callApi(searchTerm, showOnlyDeleted);
	const responseData = response.toNullable();
	if (responseData) return mapToISelectItem(responseData);
	return [];
}

export function mapFromApi(input: apiPostSearch.ResponseData): Type {
	return {
		...input,
		ranges: RangeWithIdList.mapFromApi(input),
		data: BaseIngredientList.mapFromApi(input.data),
	};
}

export function mapToISelectItem(
	input: apiGetStartingWith.ResponseBaseIngredient[]
): ISelectItem[] {
	return input.map<ISelectItem>((x: apiGetStartingWith.ResponseBaseIngredient) => ({
		id: x.id,
		name: x.description,
	}));
}
